import React from 'react';
import { Modal, Container, Row, Col, ListGroup, Card, Badge } from 'react-bootstrap';

const PaintingDetails = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable className="service-details-modal">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold display-6">
          Apex <span className="text-warning">Premium</span> Painting
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4">
        <Container>
          {/* Hero Section of Modal */}
          <div className="modal-service-hero rounded-4 mb-5 overflow-hidden position-relative" style={{ height: '300px' }}>
            <div 
              className="w-100 h-100" 
              style={{ 
                backgroundImage: "url('/painting.png')", 
                backgroundSize: 'cover', 
                backgroundPosition: 'center' 
              }}
            ></div>
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center p-5">
              <div className="text-white">
                <h2 className="fw-bold mb-3">Artistry Meets Durability</h2>
                <p className="lead mb-0">Transforming spaces with precision application, eco-friendly materials, and a commitment to aesthetic perfection.</p>
              </div>
            </div>
          </div>

          <Row className="g-4">
            <Col lg={7}>
              <h3 className="fw-bold mb-4">Our Masterpiece Process</h3>
              <div className="process-timeline">
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-warning text-white rounded-circle me-3 flex-shrink-0">1</div>
                  <div>
                    <h5 className="fw-bold">Color & Texture Consultation</h5>
                    <p className="text-muted">Our experts help you select the perfect palette and finishes, considering lighting, architecture, and the psychological impact of color.</p>
                  </div>
                </div>
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-warning text-white rounded-circle me-3 flex-shrink-0">2</div>
                  <div>
                    <h5 className="fw-bold">Meticulous Surface Preparation</h5>
                    <p className="text-muted">We believe the secret to a great finish is in the prep. This includes high-pressure washing, scraping, sanding, and filling every imperfection.</p>
                  </div>
                </div>
                <div className="process-step mb-4 d-flex">
                  <div className="step-number bg-warning text-white rounded-circle me-3 flex-shrink-0">3</div>
                  <div>
                    <h5 className="fw-bold">Precision Priming & Coating</h5>
                    <p className="text-muted">Application of high-quality primers followed by multiple coats of premium paints using specialized techniques for a uniform, durable finish.</p>
                  </div>
                </div>
                <div className="process-step mb-0 d-flex">
                  <div className="step-number bg-warning text-white rounded-circle me-3 flex-shrink-0">4</div>
                  <div>
                    <h5 className="fw-bold">Final Detailing & Site Cleanup</h5>
                    <p className="text-muted">A final walkthrough ensures every line is sharp and every corner is perfect. We leave your site cleaner than we found it.</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <Card className="border-0 bg-light rounded-4 p-4 shadow-sm mb-4">
                <h4 className="fw-bold mb-3 text-warning">Specialized Finishes</h4>
                <div className="d-flex flex-wrap gap-2 mb-3">
                  <Badge bg="white" text="dark" className="border px-3 py-2">Royal Velour</Badge>
                  <Badge bg="white" text="dark" className="border px-3 py-2">Italian Stucco</Badge>
                  <Badge bg="white" text="dark" className="border px-3 py-2">Metallic Lustre</Badge>
                  <Badge bg="white" text="dark" className="border px-3 py-2">Suede Finish</Badge>
                  <Badge bg="white" text="dark" className="border px-3 py-2">Stone Texture</Badge>
                </div>
                <p className="small text-muted mb-0">We use only low-VOC, odorless, and antimicrobial paints for a healthy indoor environment.</p>
              </Card>

              <Card className="border-0 bg-warning text-dark rounded-4 p-4 shadow-lg">
                <h4 className="fw-bold mb-3">The Apex Advantage</h4>
                <ListGroup variant="flush" className="bg-transparent">
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center text-dark">
                    <i className="fas fa-check-circle me-2"></i>
                    <strong>Dust-Free Sanding:</strong> HEPA-filtered equipment.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center text-dark">
                    <i className="fas fa-check-circle me-2"></i>
                    <strong>Edge-to-Edge Precision:</strong> Sharpest lines in the industry.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center text-dark">
                    <i className="fas fa-check-circle me-2"></i>
                    <strong>4-Year Guarantee:</strong> Against peeling and fading.
                  </ListGroup.Item>
                  <ListGroup.Item className="bg-transparent border-0 px-0 d-flex align-items-center text-dark">
                    <i className="fas fa-check-circle me-2"></i>
                    <strong>Verified Experts:</strong> Background-checked professionals.
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default PaintingDetails;